<!--充电机数据-预约充电  -->
<template>
  <div>
    <!-- 列表 -->
    <div id="btUpdateInfo" style="position: relative;">
      <el-table id="btUpdateInfoTable" v-loading="loading" :data="tableData" style="width: 100%" border>
        <el-table-column prop="createTimeZh" :label="$t('warningPage.CreatedAt')" align="center" />
        <el-table-column prop="jsonData.startTime" :label="$t('yhubReport.StartingTime')" align="center" />
        <el-table-column prop="jsonData.endTime" :label="$t('yhubReport.EndTime')" align="center">
          <template slot-scope="scope">
            {{scope.row.jsonData.endTime | endHandle}}
          </template>
        </el-table-column>
        <el-table-column prop="jsonData.type" :label="$t('AllDevices.Type')" align="center">
          <template slot-scope="scope">
            {{scope.row.jsonData.type | typeHandle}}
          </template>
        </el-table-column>
        <el-table-column prop="createBy" :label="$t('adminView.UpdateBy')" align="center" />
      </el-table>
      <!-- 列表模块————分页 -->
      <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
        <div class="pagination-container">
          <el-pagination v-if="pageshow" background current-page.sync="listQuery.pageInfo.page"
            :page-sizes="listQuery.pageInfo.pageList" :page-size="listQuery.pageInfo.limit"
            layout="total, sizes, prev, pager, next, jumper" :total="listQuery.pageInfo.total"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { pageDeviceEventLog } from '@/api/blueTooth'
import { pagination } from '@/utils/init_table'
// import i18n from '@/i18n'
import { getDateAndHour, howLongAgo } from '@/utils/updateTime.js'
let that
export default {
  props: {
    activeTab: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end,
      loading: true,
      tableData: []
    }
  },
  watch: {
    activeTab (newValue, oldValue) {
      if (newValue == 'timeCalibratePane') this.queryList()
    },
    selectDay (newValue, oldValue) {
      if (this.activeTab == 'timeCalibratePane') this.queryList()
    }
  },
  filters: {
    typeHandle (val) {
      if (val == 1) {
        return that.$t('table1.single')
      } else if (val == 2) {
        return that.$t('table1.repeat')
      } else {
        return that.$t('button.Close')
      }
    },
    endHandle (val) {
      if (val) {
        let v = val.split(':')
        if (v[0].indexOf('25') >= 0) {
          return that.$t('table1.full_stop')
        }
      }
      return val
    }
  },
  created () {
    this.queryList()
    that = this
  },
  methods: {
    queryList () {
      var param = {
        'deviceSn': this.$route.query.chargerSn,
        'endDate': '',
        'startDate': '',
        'type': 2,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      this.loading = true
      // console.log(this.selectDay)
      if (this.selectDay && this.selectDay.length > 0) {
        param.startDate = new Date(this.selectDay[0]).setHours(0, 0, 0, 0)
        param.endDate = new Date(this.selectDay[1]).setHours(0, 0, 0, 0) + 24 * 60 * 60 * 1000 - 1
      }
      pageDeviceEventLog(param).then(res => { // 基本信息
        console.log(res)
        this.loading = false
        if (res.resultCode === 1001 && res.resultModel) {
          this.tableData = res.resultModel.list || []
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          this.tableData.forEach(v => {
            if (v.createTime) v.createTimeZh = getDateAndHour(v.createTime)
            if (v.rawData) v.jsonData = JSON.parse(v.rawData)
          })
        }
      })
    },
    // 筛选改变事件
    changeSearch () {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange (val, e) {
      // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end
  }
}
</script>
